import { createSelector } from 'reselect';

import { type ApplicationState } from '~/store';

const getHelpStore = (state: ApplicationState) => state.help;

export const getHelpStatus = createSelector(
  getHelpStore,
  (helpStore): Requestable<null, null> => helpStore.status,
);
